const GENERIC_TEMPLATES = 'flight_change_free';
const AIRLINES_LIST_CMS_KEYS = Odigeo.AB.isPrimeDays ? 'flightChangeFreeAirlinesListStringPrimeDays' : 'flightChangeFreeAirlinesListString';
const DATE_LIMIT = '2021-09-30';
let flightChangeFreeAirlinesList;

const isChangeFlightFreeChargeValid = (carriers) => {
    return _isAllValidCarriers(carriers) && _isValidDateLimit(_getCurrentSearchLastDepartureDate());
};

const isFreeRebookingFilterVisible = () => {
    return _isValidDateLimit(_getCurrentSearchLastDepartureDate());
};

const _isAllValidCarriers = (carriers) => {
    const freeChargeCarriers = flightChangeFreeAirlinesList;
    return carriers.every( (currentCarrier) => Odigeo._.get(freeChargeCarriers, currentCarrier, false));
};

const _isValidDateLimit = (lastDepartureDate) => {
    return Odigeo.AB.isPrimeDays || !lastDepartureDate || Odigeo._.isEmpty(DATE_LIMIT) || lastDepartureDate <= Odigeo.Utils.parseDate(DATE_LIMIT);
};

const _getCurrentSearchLastDepartureDate = () => {
    const searchParameters = Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters'));
    return !searchParameters || Odigeo.Utils.parseDate(searchParameters.searchSegments[searchParameters.searchSegments.length - 1].dateStr);
};

const refreshFlightChangeFreeAirlines = (reset = false) => {
    return Odigeo.Templates.getGenericTemplates([GENERIC_TEMPLATES])
        .then(Odigeo._.bind(function(templates) {
            if (Odigeo._.isObject(templates)) {
                const flightChangeFreeTemplatesKeys = templates.getStaticTemplatesKeys(GENERIC_TEMPLATES);
                const flightChangeFreeAirlinesListString = Odigeo._.get(flightChangeFreeTemplatesKeys, AIRLINES_LIST_CMS_KEYS, '');
                const flightChangeFreeAirlines = _parseResultFlightChangeFreeAirlines(flightChangeFreeAirlinesListString, reset);
                flightChangeFreeAirlinesList = flightChangeFreeAirlines;
            }
        }, this));
};

const _parseResultFlightChangeFreeAirlines = (flightChangeFreeAirlinesListString, reset) => {
    const changeFlightFreeChargeList = flightChangeFreeAirlinesListString.split('#');
    const defaultFlightChangeFreeAirlines = reset ? {} : flightChangeFreeAirlinesList || {};
    return changeFlightFreeChargeList.reduce((flightChangeFreeAirlines, airlineIATACode) => {
        if (airlineIATACode) {
            flightChangeFreeAirlines[airlineIATACode] = true;
        }
        return flightChangeFreeAirlines;
    }, defaultFlightChangeFreeAirlines);
};

const _getFlightSelectionDataCarriers = (flightNumbers) => {
    const flightSelectionData = Odigeo._.isEmpty(flightNumbers)
        ? Odigeo._.get(Odigeo.Utils.parseJson(Odigeo.Session.get('flightSelectionData'))?.data, 'flightNumbers', [])
        : flightNumbers;
    return Odigeo._.uniq(
        Odigeo._.flatten(
            flightSelectionData.map((segment) => {
                return getCarriersFromFlightNumbers(segment);
            })
        )
    );
};

const getCarriersFromFlightNumbers = (flightNumbers) => {
    return flightNumbers
        .split(',')
        .map((flight) => {
            return flight.substring(0, 2);
        })
        .filter((carrier) => carrier !== '' && carrier.length === 2 && !/^\d+$/.test(carrier));
};

const isSelectedFlightChangeableForFree = function(flightNumbers) {
    const selectedFlightCarriersList = _getFlightSelectionDataCarriers(flightNumbers);
    return isChangeFlightFreeChargeValid(selectedFlightCarriersList);
};

module.exports = {
    isSelectedFlightChangeableForFree,
    refreshFlightChangeFreeAirlines,
    getCarriersFromFlightNumbers,
    isChangeFlightFreeChargeValid,
    isFreeRebookingFilterVisible,
};
